import store from '@/store';

/** 基础设置-表单配置 */
export {
  advertiser_id,
  landing_type,
  app_promotion_type,
  delivery_mode,
  marketing_goal,
  ad_type,
  name,
};

const advertiser_id = {
  label: '广告账号',
  type: 'select',
  rules: [{ required: true, message: '请选择广告账号', trigger: 'change' }],
  options: [],
  props: {
    filterable: true,
  },
  value: '',
};

const landing_type = {
  label: '推广目标',
  type: 'radio-group',
  isButton: true,
  rules: [{ required: true, message: '请选择推广目标', trigger: 'change' }],
  options: store.getters.jrttEnum.api_2_landing_type,
  value: 'APP',
  disabled: false,
};

const app_promotion_type = {
  label: '推广子目标',
  type: 'radio-group',
  isButton: true,
  rules: [{ required: true, message: '请选择推广子目标', trigger: 'change' }],
  options: store.getters.jrttEnum.api_2_app_promotion_type,
  value: 'DOWNLOAD',
  hidden: false,
};

const delivery_mode = {
  label: '投放模式',
  type: 'radio-group',
  isButton: true,
  rules: [{ required: true, message: '请选择投放模式', trigger: 'change' }],
  options: store.getters.jrttEnum.api_2_delivery_mode,
  value: 'MANUAL',
  hidden: false,
};

const marketing_goal = {
  label: '营销场景',
  type: 'radio-group',
  isButton: true,
  rules: [{ required: true, message: '请选择营销场景', trigger: 'change' }],
  options: store.getters.jrttEnum.api_2_marketing_goal,
  value: 'VIDEO_AND_IMAGE',
};

const ad_type = {
  label: '广告类型',
  type: 'radio-group',
  isButton: true,
  rules: [{ required: true, message: '请选择广告类型', trigger: 'change' }],
  options: store.getters.jrttEnum.api_2_ad_type,
  value: 'ALL',
};

const name = {
  label: '项目名称',
  type: 'input',
  rules: [{ required: true, message: '请输入项目名称', trigger: 'change' }],
  value: '',
};

